var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTl1AbtLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 74,
    viewBox: "0 0 47 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4185 44.9467C22.3709 45.7518 21.2952 46.4812 20.1957 47.1154C21.7216 48.0006 23.2475 48.888 24.7733 49.7732C25.8707 49.1391 26.9485 48.4118 27.9961 47.6045C26.6217 46.808 24.7928 45.7432 23.4185 44.9467Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1958 47.1152C19.0985 47.7494 18.0206 48.2645 16.9709 48.6692L21.5464 51.3292C22.5961 50.9245 23.6739 50.4072 24.7734 49.7731C23.2476 48.8878 21.7217 48.0004 20.1958 47.1152Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2507_8389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 48,
    width: 7,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.025 68.0318C17.0294 69.1703 17.3735 69.8499 17.9038 70.1594L22.4814 72.8173C21.9512 72.5099 21.6049 71.8303 21.6005 70.6897C21.5832 64.2377 21.5659 57.7836 21.5464 51.3294L16.9709 48.6694C16.9883 55.1236 17.0077 61.5777 17.025 68.0318Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2507_8389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.025 68.0318C17.0294 69.1703 17.3735 69.8499 17.9038 70.1594L22.4814 72.8173C21.9512 72.5099 21.6049 71.8303 21.6005 70.6897C21.5832 64.2377 21.5659 57.7836 21.5464 51.3294L16.9709 48.6694C16.9883 55.1236 17.0077 61.5777 17.025 68.0318Z",
    fill: "#394854"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2507_8389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 47,
    width: 8,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5464 51.3294C21.5658 57.7835 21.5832 64.2377 21.6005 70.6896C21.6091 73.1613 23.2237 73.4643 24.8362 72.5337C26.4486 71.603 28.0568 69.4365 28.0503 66.9669C28.033 60.5128 28.0135 54.0587 27.9962 47.6045C26.9486 48.4118 25.8707 49.1391 24.7734 49.7732C23.6739 50.4074 22.5961 50.9246 21.5464 51.3294Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2507_8389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8296 49.8705L24.8296 49.8705C23.7506 50.4928 22.6917 51.0035 21.6589 51.4062C21.6783 57.8172 21.6955 64.2282 21.7127 70.637L21.7128 70.6892L21.7128 70.6893M24.8296 49.8705L28.0503 66.9669C28.0568 69.4365 26.4486 71.603 24.8362 72.5337C23.2237 73.4643 21.6091 73.1613 21.6005 70.6896L21.7128 70.6893M24.8296 49.8705C25.8687 49.27 26.8899 48.5867 27.8844 47.8315C27.8929 50.983 27.9019 54.1345 27.9109 57.286L27.9109 57.2862C27.9201 60.5132 27.9293 63.7402 27.9379 66.9672L24.8296 49.8705ZM21.7128 70.6893C21.7171 71.9045 22.1146 72.5423 22.6624 72.7848C23.2204 73.0318 23.9865 72.8944 24.78 72.4364C26.3631 71.5227 27.9443 69.3906 27.9379 66.9672L21.7128 70.6893Z",
    fill: "#C4E9FD",
    stroke: "black",
    strokeWidth: 0.224708
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2507_8389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 52
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0701 2.65285C25.4464 -0.450848 30.3184 -0.738693 33.8355 1.30663L38.4131 3.96447C34.8938 1.92131 30.024 2.20916 24.6456 5.31286C13.9623 11.4813 5.32861 26.4349 5.36324 38.7133C5.38055 44.8125 7.53408 49.1045 11.0057 51.1216L6.43024 48.4616C2.95644 46.4444 0.805077 42.1525 0.787762 36.0533C0.750965 23.7771 9.38462 8.82345 20.0701 2.65285Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2507_8389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0701 2.65285C25.4464 -0.450848 30.3184 -0.738693 33.8355 1.30663L38.4131 3.96447C34.8938 1.92131 30.024 2.20916 24.6456 5.31286C13.9623 11.4813 5.32861 26.4349 5.36324 38.7133C5.38055 44.8125 7.53408 49.1045 11.0057 51.1216L6.43024 48.4616C2.95644 46.4444 0.805077 42.1525 0.787762 36.0533C0.750965 23.7771 9.38462 8.82345 20.0701 2.65285Z",
    fill: "#394854"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2507_8389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 40,
    height: 51
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6456 5.31282C13.9623 11.4813 5.3286 26.4349 5.36323 38.7133C5.39353 49.7278 12.3909 54.8465 21.5462 51.3294C22.5959 50.9246 23.6737 50.4074 24.7732 49.7732C25.8706 49.139 26.9484 48.4118 27.996 47.6045C37.1404 40.5595 44.0859 27.3893 44.0556 16.3749C44.0209 4.09644 35.331 -0.855614 24.6456 5.31282Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2507_8389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9274 47.5155L27.9274 47.5155C26.8835 48.32 25.8098 49.0444 24.7171 49.6759C23.6222 50.3074 22.5496 50.8221 21.5058 51.2245C16.9541 52.9731 12.9596 52.5684 10.1011 50.3814C7.24031 48.1927 5.49068 44.1986 5.47559 38.713C5.45834 32.5983 7.60024 25.8097 11.0825 19.778C14.5647 13.7463 19.3811 8.48219 24.7017 5.41013C30.0241 2.33768 34.8234 2.04884 38.289 4.02389C41.7543 5.99879 43.926 10.2599 43.9432 16.3752C43.9734 27.351 37.0472 40.4895 27.9274 47.5155Z",
    fill: "#C4E9FD",
    stroke: "black",
    strokeWidth: 0.224708
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2507_8389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 32,
    height: 40
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7841 9.23671C16.3041 14.1325 9.4539 26.0019 9.47987 35.7458C9.50801 45.4898 16.4037 49.4203 24.8837 44.5245C33.3637 39.6287 40.216 27.7593 40.1879 18.0175C40.1619 8.2714 33.2641 4.34091 24.7841 9.23671Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2507_8389)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.7841 9.23671C16.3041 14.1325 9.4539 26.0019 9.47987 35.7458C9.50801 45.4898 16.4037 49.4203 24.8837 44.5245C33.3637 39.6287 40.216 27.7593 40.1879 18.0175C40.1619 8.2714 33.2641 4.34091 24.7841 9.23671Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.2974 10.5026C39.2842 12.3209 39.6671 13.4663 40.0478 15.7539C40.4748 25.172 37.9851 30.7584 29.7952 41.0103C27.687 42.8697 26.4908 43.7793 24.2938 44.7613C35.4185 32.4839 38.7694 25.1442 38.2974 10.5026Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.79017 39.0099C12.1824 26.5297 15.299 20.2192 23.5437 10.0025L20.2928 12.5031C12.4816 21.1737 10.394 26.3049 9.29004 35.7591L9.79017 39.0099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl1AbtLens);
export default __webpack_public_path__ + "static/media/tl1-abt-lens.09c87f5532e75c311f8c9a7bf0799b6f.svg";
export { ForwardRef as ReactComponent };